// API della Plancia operativa (admin robS). Tutte le chiamate viaggiano col
// token JWT admin (ottenuto da POST /admin/login). Riusa gli endpoint
// /dashboard-pro/* perché il backend accetta il token admin su qualsiasi slug.
import axios from "axios";
import { API } from "./api";

export const ADMIN_TOKEN_KEY = "plancia_admin_token";

const authCfg = (token, extra = {}) => ({
  headers: { Authorization: `Bearer ${token}`, ...extra },
});

// ---- AUTH ----
export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  return res.data; // { token, role }
};

// ---- PLANCIA HOME ----
export const adminOverview = async (token) =>
  (await axios.get(`${API}/admin/overview`, authCfg(token))).data;

export const adminSystemStatus = async (token) =>
  (await axios.get(`${API}/admin/system-status`, authCfg(token))).data;

export const adminActivationRequests = async (token, soloDaContattare = false) =>
  (await axios.get(`${API}/admin/activation-requests?solo_da_contattare=${soloDaContattare}`, authCfg(token))).data;

export const adminMarkActivation = async (token, reqId) =>
  (await axios.patch(`${API}/admin/activation-requests/${reqId}`, { contattato: true }, authCfg(token))).data;

export const adminClients = async (token, includeArchived = false) =>
  (await axios.get(`${API}/admin/clients?include_archived=${includeArchived}`, authCfg(token))).data;

// ---- CREA / MODIFICA CLIENTE ----
export const adminCreateClient = async (token, payload) =>
  (await axios.post(`${API}/admin/clients`, payload, authCfg(token))).data;

export const adminUpdateClient = async (token, slug, payload) =>
  (await axios.patch(`${API}/admin/clients/${slug}`, payload, authCfg(token))).data;

export const adminRecharge = async (token, slug, amountEur, note = "") =>
  (await axios.post(`${API}/admin/clients/${slug}/recharge`, { amount_eur: amountEur, note }, authCfg(token))).data;

export const adminAssignNumber = async (token, slug, number) =>
  (await axios.post(`${API}/admin/clients/${slug}/number`, { number }, authCfg(token))).data;

// Archivia/ripristina (reversibile) = PATCH {archiviato}. Elimina definitivo (irreversibile) = DELETE con conferma nome.
export const adminArchiveClient = async (token, slug, archiviato) =>
  (await axios.patch(`${API}/admin/clients/${slug}`, { archiviato }, authCfg(token))).data;

export const adminDeleteClient = async (token, slug, confermaNome) =>
  (await axios.delete(`${API}/admin/clients/${slug}`, { ...authCfg(token), data: { conferma_nome: confermaNome } })).data;

// ---- DETTAGLIO CLIENTE (riuso endpoint dashboard-pro col token admin) ----
export const adminWallet = async (token, slug) =>
  (await axios.get(`${API}/dashboard-pro/${slug}/wallet`, authCfg(token))).data;

export const adminCalls = async (token, slug, page = 1) =>
  (await axios.get(`${API}/dashboard-pro/${slug}/calls?page=${page}&per_page=50`, authCfg(token))).data;

export const adminCallDetail = async (token, slug, callId) =>
  (await axios.get(`${API}/dashboard-pro/${slug}/calls/${callId}`, authCfg(token))).data;

export const adminKnowledgeList = async (token, slug) =>
  (await axios.get(`${API}/dashboard-pro/${slug}/knowledge`, authCfg(token))).data;

export const adminKnowledgeUpload = async (token, slug, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await axios.post(`${API}/dashboard-pro/${slug}/knowledge`, fd, authCfg(token, { "Content-Type": "multipart/form-data" }))).data;
};

export const adminKnowledgeDelete = async (token, slug, docId) =>
  (await axios.delete(`${API}/dashboard-pro/${slug}/knowledge/${docId}`, authCfg(token))).data;

export const adminClientSettings = async (token, slug) =>
  (await axios.get(`${API}/dashboard-pro/${slug}/settings`, authCfg(token))).data;


// ---- VISITE (statistiche sito, dal registro nginx) ----
export const adminVisite = async (token) =>
  (await axios.get(`${API}/admin/visite`, authCfg(token))).data;

// ---- helper credito → semaforo ----
export const creditColor = (bal) => {
  if (bal < 0) return "red";
  if (bal < 5) return "yellow";
  return "green";
};
export const eur = (n) => `€${(Math.round((Number(n) || 0) * 100) / 100).toFixed(2)}`;
